var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 12.4801C13 12.7452 13.2239 12.9601 13.5 12.9601H22C22.9658 12.9585 23.7483 12.2072 23.75 11.2801V9.36005C23.7489 8.43265 22.966 7.68111 22 7.68005H13.5C13.2239 7.68005 13 7.89496 13 8.16005V12.4801Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.75 12.9601H11C11.2761 12.9601 11.5 12.7452 11.5 12.4801V8.16005C11.5 7.89496 11.2761 7.68005 11 7.68005H2C1.03396 7.68111 0.251102 8.43265 0.25 9.36005V11.2801C0.251651 12.2072 1.03419 12.9585 2 12.9601H3.75Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 14.88C11.5 14.6149 11.2761 14.4 11 14.4H2.75C2.47386 14.4 2.25 14.6149 2.25 14.88V22.32C2.25165 23.2472 3.03419 23.9984 4 24H11C11.2761 24 11.5 23.7851 11.5 23.52V14.88Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 14.4C13.2239 14.4 13 14.6149 13 14.88V23.52C13 23.7851 13.2239 24 13.5 24H20C20.9658 23.9984 21.7483 23.2472 21.75 22.32V14.88C21.75 14.6149 21.5261 14.4 21.25 14.4H13.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.987 7.65112C13.648 7.73096 13.2902 7.63525 13.043 7.39868C12.8027 7.15869 12.7026 6.8197 12.776 6.49438C13.221 4.74426 13.943 2.51709 14.7 1.79041C15.8546 0.68042 17.7278 0.679077 18.884 1.78748C20.0402 2.89587 20.0415 4.69409 18.887 5.80408C18.017 6.63928 15.17 7.37366 13.987 7.65112ZM17.0502 2.89209C16.7138 2.80835 16.3566 2.90625 16.117 3.14783C15.7023 3.83411 15.389 4.57239 15.186 5.34143C15.9866 5.14539 16.7551 4.84436 17.47 4.44666C17.7216 4.21667 17.8236 3.87378 17.7364 3.5509C17.6492 3.22791 17.3865 2.97583 17.0502 2.89209Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.8 1.79041C10.555 2.51807 11.277 4.74622 11.721 6.4906C11.7972 6.81628 11.6989 7.15698 11.459 7.39868C11.2118 7.63525 10.854 7.73096 10.515 7.65125C9.33 7.37378 6.483 6.6394 5.615 5.8042C4.46045 4.6947 4.46135 2.89685 5.617 1.78845C6.77266 0.680054 8.64545 0.680908 9.8 1.79041ZM6.78213 3.55994C6.69382 3.87683 6.78831 4.21484 7.03 4.44678C7.74403 4.84534 8.51241 5.14636 9.313 5.34143C9.11047 4.57227 8.79712 3.83386 8.382 3.14783C8.14031 2.91602 7.78813 2.82556 7.45813 2.91052C7.12813 2.99561 6.87044 3.24316 6.78213 3.55994Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.a09404ec.svg";
export { ForwardRef as ReactComponent };